export default "__VITE_ASSET__JRQHP5iS__"